import { useAuth } from "~/composables/auth/useAuth";
import { useFetchProfile } from "~/composables/auth/useFetchProfile";
import { useGetProject } from "~/composables/projects/useGetProject";
import { useListProjects } from "~/composables/projects/useListProjects";
import { useGetWorkspace } from "~/composables/workspaces/useGetWorkspace";
import { useListWorkspaces } from "~/composables/workspaces/useListWorkspaces";

const PUBLIC_ROUTES = ["/login", "/signup", "/request-access"];

const isPublicRoute = (path: string): boolean => {
  return PUBLIC_ROUTES.some((route) => path.startsWith(route)) || path.includes("__og-image__");
};

export default defineNuxtRouteMiddleware(async (to, from) => {
  const token = useCookie("auth_session");
  const { fetchUserProfile, user } = useFetchProfile();
  const { workspace } = useGetWorkspace();
  const { listWorkspaces, workspaces } = useListWorkspaces();
  const { project } = useGetProject();
  const { listProjects, projects } = useListProjects();

  if (isPublicRoute(to.path)) {
    return;
  }

  if (!token.value) {
    return navigateTo({
      path: "/login",
      query: {
        redirect: to.fullPath,
      },
    });
  }

  try {
    if (!user.value?.id) {
      fetchUserProfile();
    }
    if (!workspaces.value.length) {
      await listWorkspaces();
    }
    if (!projects.value.length) {
      if (workspace.value.id) {
        await listProjects(workspace.value.id);
      }
    }
  } catch (error) {
    if (error instanceof Response && error.status === 401) {
      token.value = null;
      return navigateTo({
        path: "/request-access",
        query: {
          redirect: to.fullPath,
        },
      });
    }
    return navigateTo({
      path: "/error",
      query: {
        message: error,
        err: error,
      },
    });
  }
});
